import { Toastr } from '../../components/Toastr';

export const errorHandler = error => {
    if (error.message) {
        Toastr.error(error.message);
    } else if (error.response !== undefined) {
        if (
            error.response.data.errorKey &&
            error.response.data.errorKey[0] === 4001
        ) {
            Toastr.info(error.response.data.errorMessage);
        }

        if (
            error.response.data.errorKey &&
            error.response.data.errorKey[0] === 2003
        ) {
            Toastr.info(error.response.data.errorMessage);
        }
    }
};



// WEBPACK FOOTER //
// ./src/services/helper/error-helper.js